const FIELD_NAME_OVERRIDES: Record<string, string> = {
  snsTopic: 'SNS Topic',
  cweIds: 'CWE IDs',
  bindleLock: 'Bindle Lock',
  evaluationId: 'Evaluation ID',
  ruleId: 'Rule ID',
  resourceId: 'Resource ID',
  resourceType: 'Resource Type',
  commitId: 'Commit ID',
  versionSet: 'Version Set',
  branchName: 'Branch Name',
  packageName: 'Package Name',
  startTime: 'Start Time',
  endTime: 'End Time',
  executionTime: 'Execution Time',
  lastModifiedAt: 'Last Modified',
  lastModifiedBy: 'Last Modified By',
  versionCreatedAt: 'Version Created',
  createdAt: 'Created',
  createdBy: 'Created By',
  ruleStatus: 'Status',
  ruleVersion: 'Version',
  ruleName: 'Rule Name',
  stateReason: 'State Reason',
  appliesTo: 'Applies To',
  rawDiff: 'Raw Diff',
  findingId: 'Finding ID',
  filePath: 'File Path',
  startLine: 'Start Line',
  endLine: 'End Line',
  errorCode: 'Error Code',
  errorCategory: 'Error Category',
  stackTrace: 'Stack Trace',
  durationMs: 'Duration (ms)',
  percentComplete: 'Percent Complete',
  currentPhase: 'Current Phase',
  progressMessage: 'Progress Message',
  matchMethod: 'Match Method',
  discoveryType: 'Discovery Type',
  canonicalVersion: 'Canonical Version',
};

export function humanizeFieldName(fieldName: string): string {
  if (FIELD_NAME_OVERRIDES[fieldName]) {
    return FIELD_NAME_OVERRIDES[fieldName];
  }
  return fieldName
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function formatElapsedTime(seconds: number | undefined): string {
  if (seconds === undefined || seconds === null) return '--';
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  if (minutes < 60) return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
}
